import { doGet } from 'sos-eservice-common/js/services';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { IOccupation } from '../models/occupation.model';

export function getOccupationTexts(occupationId: string, languageBranch: string = 'sv'): Promise<IOccupation> {
    const headers = new Headers({
        'Accept-Language': languageBranch
    })
    return doGet<IOccupation>(`/_api/occupation/id/${occupationId}/${languageBranch}`, headers).then(occupationModel => {
        if (!(occupationModel instanceof ResponseError)) return occupationModel;
    });
}
